/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class TranscoderService {
  constructor(private httpClient: HttpClient) {}

  pushHRToQueue(data: any): Observable<any> {
    return this.httpClient.post<any>(`${environment.hrTranscoderHostname}/video`, data);
    // .pipe(catchError((error: any) => error));
  }

  pushGameToQueue(data: any): Observable<any> {
    return this.httpClient
      .post<any>(`${environment.gameTranscoderHostname}/`, data)
      .pipe(catchError((error: any) => error));
  }
}
